var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path5, _path6, _path7, _path8, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupedLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.05,
    y: 0.25,
    width: 12.7,
    height: 6.5,
    rx: 1.25,
    fill: "#D0D3E2",
    stroke: "#5062F0",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.442,
    y: 3.51074,
    width: 0.427994,
    height: 1.27724,
    rx: 0.213997,
    fill: "#454A67"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.084,
    y: 3.51074,
    width: 0.427994,
    height: 1.27724,
    rx: 0.213997,
    fill: "#454A67"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 3.51074,
    width: 0.427994,
    height: 1.27724,
    rx: 0.213997,
    fill: "#454A67"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.726,
    y: 3.51074,
    width: 0.641991,
    height: 1.27724,
    rx: 0.320995,
    fill: "#454A67"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.582,
    y: 3.51074,
    width: 0.213997,
    height: 1.27724,
    rx: 0.106998,
    fill: "#454A67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.796 5.29883H16.08V4.53248",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8001 4.5332V5.29955H13.298",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 3.7666V3.00026H14.582",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.084 3L11.8 3V3.76634",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.64999,
    y: 3.25,
    width: 12.7,
    height: 6.5,
    rx: 1.25,
    fill: "#D0D3E2",
    stroke: "#5062F0",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.552,
    y: 6.51074,
    width: 0.367993,
    height: 1.27724,
    rx: 0.183996,
    fill: "#454A67"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.104,
    y: 6.51074,
    width: 0.367993,
    height: 1.27724,
    rx: 0.183996,
    fill: "#454A67"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.76,
    y: 6.51074,
    width: 0.367993,
    height: 1.27724,
    rx: 0.183996,
    fill: "#454A67"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.656,
    y: 6.51074,
    width: 0.551989,
    height: 1.27724,
    rx: 0.275994,
    fill: "#454A67"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.392,
    y: 6.51074,
    width: 0.183996,
    height: 1.27724,
    rx: 0.0919981,
    fill: "#454A67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.576 8.29883H13.68V7.53248",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 7.5332V7.79955C10.0001 8.07569 10.2239 8.29955 10.5001 8.29955H11.288",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 6.7666V6.00026H12.392",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.104 6H10.5C10.2239 6 10 6.22386 10 6.5V6.76634",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 6.25,
    width: 12.7,
    height: 6.5,
    rx: 1.25,
    fill: "#D0D3E2",
    stroke: "#5062F0",
    strokeWidth: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64203,
    y: 9.51074,
    width: 0.427994,
    height: 1.27724,
    rx: 0.213997,
    fill: "#454A67"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8.284,
    y: 9.51074,
    width: 0.427994,
    height: 1.27724,
    rx: 0.213997,
    fill: "#454A67"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 10.21,
    y: 9.51074,
    width: 0.427994,
    height: 1.27724,
    rx: 0.213997,
    fill: "#454A67"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8.92604,
    y: 9.51074,
    width: 0.641991,
    height: 1.27724,
    rx: 0.320995,
    fill: "#454A67"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 9.78201,
    y: 9.51074,
    width: 0.213997,
    height: 1.27724,
    rx: 0.106998,
    fill: "#454A67"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.996 11.2988H11.28V10.5325",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 10.5332V11.2995H8.49804",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.28 9.7666V9.00026H9.782",
    stroke: "#454A67",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28398 9H7V9.76634",
    stroke: "#454A67",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedLabels);
export default __webpack_public_path__ + "static/media/groupedLabels.ab74483bec06cd028a28ada47f9fed88.svg";
export { ForwardRef as ReactComponent };